import React from 'react';
import { useNavigate } from 'react-router-dom';

function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div className="container" style={{ maxWidth: '900px', padding: '40px 20px' }}>
      <button
        onClick={() => navigate('/')}
        style={{
          background: 'transparent',
          border: '2px solid #667eea',
          color: '#667eea',
          padding: '10px 20px',
          borderRadius: '6px',
          marginBottom: '30px',
          cursor: 'pointer',
          fontSize: '1rem'
        }}
      >
        ← Back to Home
      </button>

      <div className="card">
        <h1 style={{ fontSize: '2.5rem', marginBottom: '10px' }}>Privacy Policy</h1>
        <p style={{ color: '#666', marginBottom: '30px' }}>
          <strong>Effective Date:</strong> {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
        </p>

        <div style={{ lineHeight: '1.8', color: '#333' }}>
          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>1. Introduction</h2>
            <p>
              Welcome to ViRaffle ("we," "our," or "us"). We respect your privacy and are committed to protecting your personal data.
              This privacy policy explains how we collect, use, disclose, and safeguard your information when you use our application
              integrated with GoHighLevel.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>2. Information We Collect</h2>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>2.1 Information You Provide</h3>
            <ul style={{ paddingLeft: '30px', marginBottom: '20px' }}>
              <li>Account information (name, email address)</li>
              <li>GoHighLevel location and company information</li>
              <li>Raffle campaign data (names, descriptions, prize information)</li>
              <li>Contact information for raffle participants</li>
              <li>Payment information (processed securely through Stripe or PayPal)</li>
            </ul>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>2.2 Information We Collect Automatically</h3>
            <ul style={{ paddingLeft: '30px', marginBottom: '20px' }}>
              <li>Usage data and analytics</li>
              <li>Device information (browser type, operating system)</li>
              <li>IP address and location data</li>
              <li>Cookies and similar tracking technologies</li>
            </ul>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>2.3 Information from Third Parties</h3>
            <ul style={{ paddingLeft: '30px' }}>
              <li>GoHighLevel account data (via OAuth)</li>
              <li>Contact information from your GHL account</li>
              <li>Payment confirmation from Stripe/PayPal</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>3. How We Use Your Information</h2>
            <p style={{ marginBottom: '15px' }}>We use your information to:</p>
            <ul style={{ paddingLeft: '30px' }}>
              <li>Provide and maintain our raffle management services</li>
              <li>Process your transactions and manage subscriptions</li>
              <li>Send raffle notifications and winner announcements</li>
              <li>Improve our application and develop new features</li>
              <li>Communicate with you about service updates</li>
              <li>Comply with legal obligations</li>
              <li>Prevent fraud and ensure security</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>4. GoHighLevel Integration</h2>
            <p style={{ marginBottom: '15px' }}>
              ViRaffle integrates with GoHighLevel through their official OAuth system. When you install our app:
            </p>
            <ul style={{ paddingLeft: '30px', marginBottom: '15px' }}>
              <li>We request specific permissions to access your GHL account data</li>
              <li>We securely store OAuth tokens to maintain the connection</li>
              <li>We sync contact information to manage raffle entries</li>
              <li>We use webhooks to receive real-time updates from GHL</li>
            </ul>
            <p>
              You can revoke ViRaffle's access to your GHL account at any time through your GHL settings.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>5. Data Sharing and Disclosure</h2>
            <p style={{ marginBottom: '15px' }}>We may share your information with:</p>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>Service Providers</h3>
            <ul style={{ paddingLeft: '30px', marginBottom: '20px' }}>
              <li><strong>GoHighLevel:</strong> For platform integration and data synchronization</li>
              <li><strong>Stripe/PayPal:</strong> For payment processing</li>
              <li><strong>Email Service Provider:</strong> For sending notifications</li>
              <li><strong>Cloud Hosting:</strong> For data storage and application hosting</li>
            </ul>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>Legal Requirements</h3>
            <p>We may disclose your information if required by law, court order, or government request.</p>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>Business Transfers</h3>
            <p>If ViRaffle is involved in a merger, acquisition, or sale, your information may be transferred as part of that transaction.</p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>6. Data Security</h2>
            <p style={{ marginBottom: '15px' }}>We implement industry-standard security measures to protect your data:</p>
            <ul style={{ paddingLeft: '30px' }}>
              <li>SSL/TLS encryption for data in transit</li>
              <li>Encrypted database storage</li>
              <li>Secure OAuth token management</li>
              <li>Regular security audits and updates</li>
              <li>Access controls and authentication requirements</li>
              <li>Payment data processed only through PCI-compliant providers</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>7. Data Retention</h2>
            <p>
              We retain your personal data only as long as necessary to provide our services and comply with legal obligations.
              When you delete your account, we will delete or anonymize your personal data within 30 days, except where we are
              legally required to retain certain information.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>8. Your Rights</h2>
            <p style={{ marginBottom: '15px' }}>You have the right to:</p>
            <ul style={{ paddingLeft: '30px' }}>
              <li><strong>Access:</strong> Request a copy of your personal data</li>
              <li><strong>Correction:</strong> Update or correct inaccurate data</li>
              <li><strong>Deletion:</strong> Request deletion of your personal data</li>
              <li><strong>Portability:</strong> Receive your data in a machine-readable format</li>
              <li><strong>Object:</strong> Object to certain data processing activities</li>
              <li><strong>Withdraw Consent:</strong> Revoke consent for data processing</li>
            </ul>
            <p style={{ marginTop: '15px' }}>
              To exercise these rights, please contact us at <a href="mailto:privacy@aiandautomationmarketing.com" style={{ color: '#667eea' }}>privacy@aiandautomationmarketing.com</a>
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>9. Cookies and Tracking</h2>
            <p style={{ marginBottom: '15px' }}>We use cookies and similar technologies to:</p>
            <ul style={{ paddingLeft: '30px', marginBottom: '15px' }}>
              <li>Maintain your logged-in session</li>
              <li>Remember your preferences</li>
              <li>Analyze usage patterns and improve our service</li>
              <li>Provide security features</li>
            </ul>
            <p>
              You can control cookie settings through your browser preferences. Note that disabling cookies may affect
              some functionality of ViRaffle.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>10. International Data Transfers</h2>
            <p>
              Your information may be transferred to and processed in countries other than your country of residence.
              We ensure appropriate safeguards are in place to protect your data in accordance with this privacy policy.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>11. Children's Privacy</h2>
            <p>
              ViRaffle is not intended for users under 18 years of age. We do not knowingly collect personal information
              from children. If you believe we have collected information from a child, please contact us immediately.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>12. Changes to This Privacy Policy</h2>
            <p>
              We may update this privacy policy from time to time. We will notify you of significant changes by email or
              through a notice in the application. Your continued use of ViRaffle after changes are posted constitutes
              acceptance of the updated policy.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>13. California Privacy Rights (CCPA)</h2>
            <p style={{ marginBottom: '15px' }}>If you are a California resident, you have additional rights under the CCPA:</p>
            <ul style={{ paddingLeft: '30px' }}>
              <li>Right to know what personal information is collected</li>
              <li>Right to know if personal information is sold or disclosed</li>
              <li>Right to opt-out of the sale of personal information</li>
              <li>Right to deletion of personal information</li>
              <li>Right to non-discrimination for exercising CCPA rights</li>
            </ul>
            <p style={{ marginTop: '15px' }}>
              <strong>Note:</strong> ViRaffle does not sell your personal information.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>14. European Users (GDPR)</h2>
            <p style={{ marginBottom: '15px' }}>If you are in the European Economic Area (EEA), you have rights under GDPR:</p>
            <ul style={{ paddingLeft: '30px' }}>
              <li>Legal basis for processing your data (consent, contract, legitimate interest)</li>
              <li>Right to lodge a complaint with your local data protection authority</li>
              <li>Data Protection Officer contact (if applicable)</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>15. Contact Us</h2>
            <p style={{ marginBottom: '15px' }}>
              If you have questions about this privacy policy or our data practices, please contact us:
            </p>
            <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px', marginTop: '20px' }}>
              <p style={{ margin: '5px 0' }}><strong>Email:</strong> <a href="mailto:privacy@aiandautomationmarketing.com" style={{ color: '#667eea' }}>privacy@aiandautomationmarketing.com</a></p>
              <p style={{ margin: '5px 0' }}><strong>Support:</strong> <a href="mailto:support@aiandautomationmarketing.com" style={{ color: '#667eea' }}>support@aiandautomationmarketing.com</a></p>
              <p style={{ margin: '5px 0' }}><strong>Website:</strong> <a href="https://viraffle.aiandautomationmarketing.com" style={{ color: '#667eea' }}>viraffle.aiandautomationmarketing.com</a></p>
            </div>
          </section>

          <div style={{
            marginTop: '50px',
            paddingTop: '30px',
            borderTop: '2px solid #e0e0e0',
            textAlign: 'center',
            color: '#666'
          }}>
            <p style={{ fontSize: '0.9rem' }}>
              © {new Date().getFullYear()} ViRaffle. All rights reserved.
            </p>
            <p style={{ fontSize: '0.85rem', marginTop: '10px' }}>
              <a href="/terms" style={{ color: '#667eea', marginRight: '20px' }}>Terms of Service</a>
              <a href="/support" style={{ color: '#667eea' }}>Support</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
